












































import { Component, Vue } from "vue-property-decorator";
import ModuleTransition from "@/components/ModuleTransition.vue";
import { Mos } from "@/interfaces/general";
import { mapState } from "vuex";

@Component({
  metaInfo() {
    return {
      title: "Mos - Modules"
    };
  },
  components: { ModuleTransition },
  computed: {
    ...mapState("module", ["name"])
  },
  methods: {}
})
export default class Modules extends Vue {
  modules = [
    "Reconciliation",
    "Access Manager",
    "Mos",
    "Mining Production",
    "Continuous Improvement"
  ];
  select = "Reconciliation";
  mos: Mos[] = [
    {
      title: "Reconciliation",
      items: [
        "modules/reconciliation/summary.svg",
        "modules/reconciliation/classifications.svg",
        "modules/reconciliation/Data Entry.svg"
      ],
      link: process.env.VUE_APP_RECONCILIATION,
      information: [
        {
          id: 0,
          title: "Dashboards",
          text: [
            "The Dashboard engine are the basis for all MOS panels when on the Endeavor network or connected via VPN. It allows users to:",
            "- See standard control panels",
            "- Create custom panels",
            "- Use standard or custom widgets for use in dashboards",
            "- Search global or custom dashboards by keyword or search term",
            "- Post custom dashboards for others to see / use"
          ]
        },
        {
          id: 1,
          title: "Values Management",
          text: [
            "The Values Management allows adding, editing and eliminating different classifications, characteristics, metrics, locations among other groups of data that are used in the reconciliation process."
          ]
        },
        {
          id: 2,
          title: "Data Import",
          text: [
            "This MOS service allows the import of files in .csv and .xlsx formats, offers the option of analysis for mapping the variables associated with the different processes and their processing for loading and the link with the visualization and analysis tools."
          ]
        }
      ]
    },
    {
      title: "Access Manager",
      items: [
        "modules/access manager/menu.svg",
        "modules/access manager/nomenu.svg",
        "modules/access manager/user.svg"
      ],
      link: process.env.VUE_APP_ACCESS_MANAGER,
      information: [
        {
          id: 0,
          title: "Modules Access",
          text: [
            "In this menu panel, you can see the set of Modules and Tools of the MOS ecosystem, to which a user has access based on their role."
          ]
        },
        {
          id: 1,
          title: "Permissions Requests",
          text: [
            "This list menu allows yo view the user who requests access to the different modules based on the role they play."
          ]
        },
        {
          id: 2,
          title: "Users",
          text: [
            "With the administrator role it is possible to edit the general data of the user, and manage the extra roles and policies per site."
          ]
        }
      ]
    },
    {
      title: "Mos",
      items: [
        "modules/reconciliation/Data Entry.svg",
        "modules/reconciliation/summary.svg",
        "modules/reconciliation/classifications.svg"
      ],
      link: process.env.VUE_APP_MOS,
      information: [
        {
          id: 0,
          title: "Dashboards",
          text: [
            "Laorem ipxsum dolor sit amet, consectetur adipiscing elit. Integer enim tellus, euismod quis placerat et, tristique sed risus. Maecenas viverra malesuada massa, at efficitur odio fermentum id. Donec ac massa lorem. Nunc auctor vulputate pellentesque. Nulla vel consequat dui, in consectetur tortor. Fusce condimentum, lorem sit amet finibus fringilla, ante nisi elementum ex, quis consequat tortor lectus id odio. In hac habitasse platea dictumst."
          ]
        },
        {
          id: 1,
          title: "Data Import",
          text: [
            " Pellenxtesque tempor interdum est eu fringilla. Cras quis tristique eros, et tempus est. Morbi congue, ligula sit amet auctor lacinia, nunc sapien efficitur purus, vitae sollicitudin urna nunc vitae est. Nam vitae quam maximus, dictum ex et, blandit nisl."
          ]
        },
        {
          id: 2,
          title: "Values Management",
          text: [
            "Vivamus suscipit mattis lectus nec facilisis. Duis ac ipsum vitae justo pellentesque feugiat. Aliquam in ipsum sit amet ante molestie lobortis. Maecenas sit amet viverra justo, in faucibus ipsum. Nunc porttitor vestibulum ex, at laoreet velit venenatis id. Morbi luctus mauris sit amet leo gravida maximus. Cras vitae odio suscipit, ultricies ex bibendum, lobortis augue. Vestibulum tristique tempor ipsum at pulvinar. Nunc vitae purus metus."
          ]
        }
      ]
    },
    {
      title: "Mining Production",
      items: [
        "modules/mining production/grade control.svg",
        "modules/mining production/dashboard.svg",
        "modules/mining production/report.svg"
      ],
      link: process.env.VUE_APP_MINING_PRODUCTION,
      information: [
        {
          id: 0,
          title: "Fleet Control",
          text: [
            "In elementum dui quis eros aliquet, et sodales velit ultricies. Vestibulum sit amet odio ac felis facilisis porta. Proin non diam et mi interdum malesuada. Aenean ut lectus metus. Suspendisse vel convallis odio, sed facilisis tellus. Phasellus vestibulum blandit ipsum, in aliquet lacus molestie eu. Vivamus eget fringilla tortor, non congue justo. Proin suscipit bibendum magna vitae egestas. In imperdiet mi sit amet luctus vestibulum. Nunc tincidunt, mauris ultricies placerat pellentesque, risus leo aliquam ligula, at hendrerit est leo vulputate quam."
          ]
        },
        {
          id: 1,
          title: "Dashboard",
          text: [
            "Donec in neque velit. Aenean eget velit ac justo pharetra lacinia. Phasellus maximus, risus vel vehicula ultricies, purus odio egestas justo, et condimentum ex lectus sit amet magna. Praesent varius blandit fermentum. Maecenas quis dolor at eros congue blandit sit amet nec velit. Aliquam dolor odio, condimentum in varius et, feugiat aliquet lacus."
          ]
        },
        {
          id: 2,
          title: "Report",
          text: [
            "Donec sodales luctus finibus. Integer id porttitor leo, vitae ultrices ante. Phasellus et laoreet tortor, ornare molestie enim. Fusce a metus elit. Nulla fermentum leo sit amet dolor egestas placerat. Nam pulvinar, neque eget consectetur porttitor, nibh purus semper turpis, id efficitur eros quam vitae neque. Aenean id condimentum nulla. Proin ut sollicitudin nunc.r"
          ]
        }
      ]
    },
    {
      title: "Continuous Improvement",
      items: [
        "modules/improvement funnel/ideas.svg",
        "modules/improvement funnel/dashboard.svg",
        "modules/improvement funnel/innovation funnel.svg"
      ],
      link: process.env.VUE_APP_CONTINUOUS_IMPROVEMENT,
      information: [
        {
          id: 0,
          title: "Ideas",
          text: [
            "In elementum dui quis eros aliquet, et sodales velit ultricies. Vestibulum sit amet odio ac felis facilisis porta. Proin non diam et mi interdum malesuada. Aenean ut lectus metus. Suspendisse vel convallis odio, sed facilisis tellus. Phasellus vestibulum blandit ipsum, in aliquet lacus molestie eu. Vivamus eget fringilla tortor, non congue justo. Proin suscipit bibendum magna vitae egestas. In imperdiet mi sit amet luctus vestibulum. Nunc tincidunt, mauris ultricies placerat pellentesque, risus leo aliquam ligula, at hendrerit est leo vulputate quam."
          ]
        },
        {
          id: 1,
          title: "Dashboard",
          text: [
            "Donec in neque velit. Aenean eget velit ac justo pharetra lacinia. Phasellus maximus, risus vel vehicula ultricies, purus odio egestas justo, et condimentum ex lectus sit amet magna. Praesent varius blandit fermentum. Maecenas quis dolor at eros congue blandit sit amet nec velit. Aliquam dolor odio, condimentum in varius et, feugiat aliquet lacus."
          ]
        },
        {
          id: 2,
          title: "Innovation Funnel",
          text: [
            "Donec sodales luctus finibus. Integer id porttitor leo, vitae ultrices ante. Phasellus et laoreet tortor, ornare molestie enim. Fusce a metus elit. Nulla fermentum leo sit amet dolor egestas placerat. Nam pulvinar, neque eget consectetur porttitor, nibh purus semper turpis, id efficitur eros quam vitae neque. Aenean id condimentum nulla. Proin ut sollicitudin nunc.r"
          ]
        }
      ]
    }
  ];
  name!: string;

  get MarginTop(): string {
    return this.$vuetify.breakpoint.smAndDown
      ? "margin-top: 0"
      : "margin-top: calc(100vh/8)";
  }
  mounted() {
    if (this.name !== "") {
      this.select = this.name;
    }
  }
}
